import { gql } from '@apollo/client'
import React from 'react'

import { placesClient } from '../../../../utils/apollo/api'
import { useModalData } from '../../../../components/modals/ModalsContext'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePlaceTypeState = () => React.useContext(Context)
export const usePlaceType = () => usePlaceTypeState()?.placeType

const QUERY = gql`
  query PlaceType($key: String) {
    placeType(key: $key) {
      id
      name
      namePlural
      icon
      key
      updatedAt
      insertedAt
    }
  }
`

const PlaceTypeLoader = ({ children }) => {
  const { key } = useModalData()
  const { data, ...state } = useQuery(QUERY, {
    variables: { key },
    skip: !key,
    client: placesClient,
    fetchPolicy: 'network-only'
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PlaceTypeLoader
